import { RatingScheduledEntry } from 'lib-shared-legacy-types';

import { LogEntry } from './logEntry';

type RatingScheduledProps = {
  entry: RatingScheduledEntry;
};

export const RatingScheduled = ({
  entry,
}: RatingScheduledProps): JSX.Element => {
  const action =
    entry.activity_type === 'CONVERSATION_RATING_SCHEDULED'
      ? 'scheduled'
      : 'unscheduled';

  const text =
    `Conversation rating is ${action}` +
    (entry.rating_scheduled_time
      ? ` at ${new Date(entry.rating_scheduled_time).toLocaleString()}`
      : '');

  return <LogEntry entry={entry} text={text} />;
};
